module.exports = __webpack_public_path__ + "web-assets/img/audit.f583a217.png";